import { useEffect } from "react";
import { EnglishToPersian } from "numeral-convert";
import { useDispatch, useSelector } from "react-redux";
import { selectWaterType } from "../features/request/requestSlice";
import { selectCallApi, selectCurrentPage, setCurrentPage } from "../features/common-states/commonStatesSlice";

const Pagination = ({ handleChangePage, totalPages = 20 }) => {
const dispatch = useDispatch();
const selectedItem = useSelector(selectCurrentPage);

const handleClick = (item) => {
  if (item < 1 || item > totalPages) return;

  dispatch(setCurrentPage(item));
  handleChangePage(item)
};
  const waterType = useSelector(selectWaterType);
  const callApi = useSelector(selectCallApi);

  const getPages = () => {
    const range = 2;

    let start = Math.max(1, selectedItem - range);
    let end = Math.min(totalPages, selectedItem + range);

    const pages = [];

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    return pages;
  };

  // const handleClick = (item) => {
  //   if (item < 1 || item > totalPages) return;

  //   setSelectedItem(item);
  //   handleChangePage(item);
  // };

  useEffect(() => {
  dispatch(setCurrentPage(1));
    // eslint-disable-next-line
  }, [waterType, callApi]);

  const pages = getPages();

  return (
    <div
      className="pagination-box flex flex-row-reverse my-10 mx-auto w-max border border-gray-200 rounded-md overflow-hidden
      text-xs [&_div]:py-1 sm:[&_div]:py-2 [&_div]:px-2 sm:[&_div]:px-3 [&_div]:cursor-pointer [&_div]:select-none max-w-full"
    >
      <div
        className="hover:bg-green-400 hover:text-white !px-1"
        onClick={() => handleClick(selectedItem - 1)}
      >
        <span>قبلی</span>
        <i className="fa fa-angle-double-right mx-1"></i>
      </div>

      {/* صفحات */}
      {pages.map((item, index) => {
        if (item === "...") {
          return (
            <div key={index} className="px-2 cursor-default">
              ...
            </div>
          );
        }

        return (
          <div
            key={index}
            className={`hover:bg-green-400 hover:text-white border-r ${
              selectedItem === item && "!bg-green-500 text-white"
            }`}
            onClick={() => handleClick(item)}
          >
            {EnglishToPersian(item.toString())}
          </div>
        );
      })}

      {/* دکمه بعدی */}
      <div
        className="hover:bg-green-400 hover:text-white border-r !px-1"
        onClick={() => handleClick(selectedItem + 1)}
      >
        <i className="fa fa-angle-double-left mx-1"></i>
        <span>بعدی</span>
      </div>
    </div>
  );
};

export default Pagination;
